import type { InsuranceQuoteResponseDTO } from '~/dto/Insurance/insuranceQuoteResponseDTO';
import type { InsuranceQuoteEntity } from '~/domain/Insurance/insuranceQuoteEntity';
import type { MarisaAuto } from '~/@types/MarisaAuto/form';
const parsePaymentOptionToBestPaymentOption = (
  paymentMethod: MarisaAuto.PaymentType,
  installment: MarisaAuto.Instalment
): MarisaAuto.BestPaymentOption => {
  return {
    description: paymentMethod.descricao,
    type: paymentMethod.tipo,
    installments: Number(installment.numero),
    installmentValue: Number(installment.valor),
    totalPrice: installment.valorTotal,
  };
};

const bestPaymentOptionMapper = (
  item: MarisaAuto.InsuranceQuote
): MarisaAuto.BestPaymentOption => {
  const fistOption = parsePaymentOptionToBestPaymentOption(
    item.formaPagamento[0]!,
    item.formaPagamento[0]!.parcelas[0]!
  );
  return item.formaPagamento.reduce((prev, curr) => {
    const bestInstallment = curr.parcelas.reduce(
      (prevInstallment, currInstallment) =>
        currInstallment.valor < prevInstallment.valor
          ? currInstallment
          : currInstallment
    );
    if (Number(bestInstallment.valor) < prev.installmentValue) {
      return parsePaymentOptionToBestPaymentOption(curr, bestInstallment);
    }
    return prev;
  }, fistOption);
};

export const insuranceQuoteResponseMapper = ({
  success,
  resultData,
}: InsuranceQuoteResponseDTO): InsuranceQuoteEntity => {
  if (success && resultData.length > 0) {
    return <InsuranceQuoteEntity>{
      success,
      insuranceQuotes: resultData
        .sort((a, b) => {
          const aValue =
            Number(a?.formaPagamento?.[0]?.parcelas?.[0]?.valor) || 0;
          const bValue =
            Number(b?.formaPagamento?.[0]?.parcelas?.[0]?.valor) || 0;

          return aValue - bValue;
        })
        .map((item) => {
          return {
            ...item,
            bestPaymentOption: bestPaymentOptionMapper(item),
            coberturas: Array.isArray(item.coberturas)
              ? item.coberturas
              : (Object.values(item.coberturas) as MarisaAuto.Coverage[]),
          };
        }),
    };
  }
  return { success: false, insuranceQuotes: [] };
};
